// eslint-disable-next-line import/named
import { autoElement } from '../../../webmodule-common/components/src/webmodule-components';
import { getApiToken } from '../../../webmodule-common/other/api/current-user';
import { html } from 'lit';

import { PageControlTabWithIndependantSaving } from '../../../webmodule-common/other/ui/data-entry-screen-base';
import { PromiseTemplate, Snippet } from '../../../webmodule-common/other/ui/events';
import { tlang } from '../../../webmodule-common/other/language/lang';
import { state } from 'lit/decorators.js';
import {
  ICynclySupportPage,
  ILicenseServerUICynclySupportPageProvider,
  licenseServerUIBootLoader
} from '../../common/licenseserver-integration';

@autoElement()
export class CynclySupportView extends PageControlTabWithIndependantSaving {
  provider: ILicenseServerUICynclySupportPageProvider = {
    credentials: {
      host: globalThis.dealerConfiguration.licenseServerHost,
      token: getApiToken()
    }
  };
  @state()
  userConsole?: ICynclySupportPage;

  constructor() {
    super();
    this.pageFragment = 'cynclysupport';
  }

  async reloadData() {
    const licUI = await licenseServerUIBootLoader();
    this.userConsole = licUI?.getCynclyAccessPage?.(this.provider);

    await this.refreshParent();
  }

  buttonMenu(): Snippet {
    const buttons = this.userConsole?.actions().map(x => {
      return html` <button class="btn btn-primary" ?disabled=${!x.enabled} @click=${x.event}>${x.label}</button>`;
    });
    return html`${buttons}`;
  }

  public internalDataChanged(): boolean {
    return false;
  }

  async onEnter(): Promise<void> {
    await this.reloadData();
  }

  public allowDeletePage(): boolean {
    return false;
  }

  async prepareForSave(): Promise<void> {
    //
  }

  protected async internalSaveData(): Promise<boolean> {
    //nothing to do
    return true;
  }

  protected getCaption(): Snippet {
    return tlang`Tenant Network`;
  }

  protected async bodyTemplate(): PromiseTemplate {
    return this.userConsole?.template() ?? html``;
  }
}
